package com.appsyde.shared.modules.team.data

import kotlinx.serialization.Serializable

@Serializable
data class UserListItemDto(
    val id: String,
    val email: String,
    val role: String,
    val status: String,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class InviteListItemDto(
    val id: String,
    val email: String,
    val expiresAt: String,
    val usedAt: String? = null,
    val revokedAt: String? = null,
    val createdAt: String
)

@Serializable
data class CreateInviteRequestDto(val email: String)

@Serializable
data class CreateInviteResponseDto(val inviteId: String)
